import * as Sentry from '@sentry/react'

const Styles = 'padding: .1rem; background: #ce1010; color: #fff'

export default {
    send: function (moduleSource, errorType, data) {

        const isProductionMode = (
            process.env.NODE_ENV != 'development'
        )

        if (isProductionMode) {
            Sentry.captureException({
                logger: moduleSource,
                level: errorType,
                extra: {
                    message: data
                }
            })
        }

        console.info('%c SentryReporter (' +
            ((!isProductionMode) ? 'No Send' : 'Sent') +
        ')', Styles)
        console.info('%c Source: %s', Styles, moduleSource)
        console.info('%c Error Type: %s', Styles, errorType)
        console.info('%c Data:', Styles)
        console.log(data);
    }
}